import { listByType, queryBySiteId } from '@/services/home';
import { history, useRequest } from '@umijs/max';
import { useEffect, useState } from 'react';

const Header1 = () => {
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedKeys, setSelectedKeys] = useState([]);
  const { data: dataNav, run: runNav } = useRequest(listByType, {
    manual: true,
  });
  const { data: dataFooter, run: runFooter } = useRequest(queryBySiteId, {
    manual: true,
  });
  let sites = dataFooter?.resData?.externalLinkList
    ?.filter((item) => item.main === '1')
    ?.map((item) => {
      return {
        name: item.linkName,
        url: item.linkAddress,
      };
    }) || [
    {
      name: '浙江建材',
      url: 'https://www.zjsjcjt.com/',
    },
    {
      name: '浙江建工',
      url: 'https://www.zjsjg.com/',
    },
    {
      name: '浙江一建',
      url: 'https://www.zyjjt.com/',
    },
    {
      name: '浙江二建',
      url: 'https://www.zjej.com/',
    },
    {
      name: '浙江三建',
      url: 'https://www.ccjsjt.cn/',
    },
    {
      name: '浙江安装',
      url: 'https://www.zjkygroup.com/',
    },
    {
      name: '浙江交建',
      url: 'https://www.zjsjjjt.com/',
    },
    {
      name: '浙江建机',
      url: 'https://www.zjjj.com.cn/',
    },
    {
      name: '浙江建投装饰',
      url: 'https://www.50jz.com/',
    },
    {
      name: '浙建商贸物流',
      url: 'https://www.zjsmwl.com/',
    },
    {
      name: '浙建物资设备',
      url: 'https://www.zjjtwz.com/',
    },
    {
      name: '浙建环保',
      url: 'https://www.zjjstzhb.com/',
    },
  ];
  //mock数据
  let headerListMock = [
    {
      label: '首页',
      key: '/home',
    },
    {
      label: '集团概况',
      key: '/home/jtgk',
      children: [
        {
          label: '集团简介',
          key: '/home/jtgk#jtjj',
        },

        {
          label: '发展历程',
          key: '/home/jtgk#fzlc',
        },
        {
          label: '市场分布',
          key: '/home/jtgk#scfb',
        },
        {
          label: '企业资质',
          key: '/home/jtgk#qyzs',
        },
        {
          label: '企业荣誉',
          key: '/home/jtgk#qyry',
        },
        {
          label: '联系我们',
          key: '/home/jtgk#lxwm',
        },
      ],
    },
    {
      label: '新闻资讯',
      key: '/home/news',

      children: [
        {
          label: '集团要闻',
          key: '/home/news#jtyw',
        },
        {
          label: '成员动态',
          key: '/home/news#cydt',
        },
      ],
    },
    {
      label: '业务板块',
      key: '/home/ywbk',
      children: [
        {
          label: '建筑施工',
          key: '/home/ywbk/jzsg',
        },
        {
          label: '工程设计',
          key: '/home/ywbk/gcsj',
        },
        {
          label: '产业投资',
          key: '/home/ywbk/cytz',
        },
        {
          label: '工业制造',
          key: '/home/ywbk/gyzz',
        },
        {
          label: '专业运营服务',
          key: '/home/ywbk/zyyw',
        },
      ],
    },
    {
      label: '企业文化',
      key: '/home/qywh',
      children: [
        {
          label: '经典工程',
          key: '/home/qywh#jdgc',
        },

        {
          label: '群英谱',
          key: '/home/qywh#qyp',
        },
        {
          label: '浙建人',
          key: '/home/qywh#zjr',
        },
        {
          label: '文化活动',
          key: '/home/qywh#whhd',
        },
        {
          label: '文化故事',
          key: '/home/qywh#whgs',
        },
        {
          label: '文化元素',
          key: '/home/qywh#whys',
        },
      ],
    },
    {
      label: '科技创新',
      key: '/home/kjcx',
      children: [
        {
          label: '研发平台',
          key: '/home/kjcx#yfpt',
        },
        {
          label: '科技成果',
          key: '/home/kjcx#kjcg',
        },
        {
          label: '科研项目',
          key: '/home/kjcx#kyxm',
        },
      ],
    },
    {
      label: '信息发布',
      key: '/home/information',
      children: [
        {
          label: '重大信息公开',
          key: '/home/information#zdxxgk',
        },
        {
          label: '经营政策解读',
          key: '/home/information#jyzcjd',
        },
        {
          label: 'ESG报告',
          key: '/home/information#esgbg',
        },
        {
          label: '招标投公告',
          key: '/home/information#ztbgg',
        },
      ],
    },
    {
      label: '加入我们',
      key: '/home/join',
      children: [
        {
          label: '招聘公告',
          key: '/home/join#zpgg',
        },
        {
          label: '校园招聘',
          key: '/home/join#xyzp',
        },
        {
          label: '社会招聘',
          key: '/home/join#shzp',
        },
      ],
    },
    {
      label: '投资者关系',
      key: '/home/investor',
      children: [
        {
          label: '投资者服务',
          key: '/home/investor#tzzfw',
        },
      ],
    },
  ];
  let headerList1 = dataNav?.resData?.map((item) => {
    return {
      label: item.name,
      key: item?.internalLink || item?.externalLink || item?.path || item?.id,
      //如果是空数组，好像没触发点击事件。所以这里判断一下。
      children:
        item.children?.length > 0
          ? item.children?.map((child) => {
              return {
                label: child.name,
                key:
                  child?.internalLink ||
                  child?.externalLink ||
                  child.path ||
                  `${item.path}#${child?.id}`,
              };
            })
          : undefined,
    };
  });
  useEffect(() => {
    // 导航
    runNav({
      siteId: 'ST-20241124222158',
    });
    // 页脚
    runFooter({
      siteId: 'ST-20241124222158',
    });
  }, []);

  //锚点滚动

  const scrollToAnchor = (key, height) => {
    const [path, hash] = key.split('#');
    let defaultHeight = 60;
    if (window.innerWidth < 1200) {
      defaultHeight = 80;
    }
    const headerHeight = height || defaultHeight; // Header 固定高度-滚动的话，要去除头部
    if (hash) {
      // 如果已经在目标路由，直接滚动
      if (window.location.pathname === path) {
        history.push(key);
        const element = document.getElementById(hash);
        if (element) {
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerHeight;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      } else {
        // 先跳转路由，然后等待 DOM 更新后滚动
        history.push(key);
        setTimeout(() => {
          const element = document.getElementById(hash);
          if (element) {
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition =
              elementPosition + window.pageYOffset - headerHeight;
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth',
            });
          }
        }, 100);
      }
    } else {
      console.log(headerHeight, height, 288);

      history.push(key);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }, 100);
    }
  };

  return {
    name: 'header',
    sites,
    headerList: headerList1 || headerListMock,
    dataFooter: dataFooter?.resData,
    scrollToAnchor,
    searchKeyword,
    setSearchKeyword,
    selectedKeys,
    setSelectedKeys,
  };
};

export default Header1;
